module.exports = __webpack_public_path__ + "img/centos.4d8c006e.svg";